import { PulseEnvironment } from '@pulse/browser-shared';
import {
    AnalyticsPlugin,
    BuiltinEvents,
    ConsentChange,
    PulseEvent,
    PulseMessagePriority,
} from '@pulse/common';
import { filter } from 'rxjs';
import { DeviceAttributesService, SessionService, TrackingConsentService } from '../../../services';
import { TrackingConsentStateChangeEvent } from './concent-event';

export class ConsentEventPlugin implements AnalyticsPlugin {
    constructor(
        private consentService: TrackingConsentService,
        private sessionService: SessionService,
        private attributeService: DeviceAttributesService,
        private env: PulseEnvironment,
    ) {}

    init() {
        this.consentService
            .changes()
            .pipe(filter((change) => change.consent.report !== false))
            .subscribe((change) => {
                this.fireChangeEvent(change);
                if (change.consent.mode === 'opt-in') {
                    this.sessionService.startNewSession('consent_change');
                    this.attributeService.send();
                }
            });
    }

    private fireChangeEvent(change: ConsentChange) {
        const data = this.buildChangeEvent(change);
        const event: PulseEvent<TrackingConsentStateChangeEvent> = {
            event_type: BuiltinEvents.CONSENT_CHANGE,
            data,
        };
        this.env.win.dataLayer?.push({
            pulse: 'event',
            ...event,
            event_priority: PulseMessagePriority.Force,
        });
    }

    private buildChangeEvent({ consent, result }: ConsentChange): TrackingConsentStateChangeEvent {
        const provider =
            typeof consent.consent === 'string' ? consent.consent : consent.consent.name;

        return {
            mode: consent.mode,
            provider,
            state: result.state,

            necessary_cookies: result.necessary_cookies ?? undefined,
            performance_cookies: result.performance_cookies ?? undefined,
            functional_cookies: result.functional_cookies ?? undefined,
            targeting_cookies: result.targeting_cookies ?? undefined,
            social_media_cookies: result.social_media_cookies ?? undefined,

            provider_consent_id: result.provider_consent_id ?? undefined,
            response_time: result.response_time ?? undefined,
        };
    }
}
